import React from "react";
import PropTypes from "prop-types";
import { withStyles } from "@material-ui/core/styles";
import TabsComponent from "@material-ui/core/Tabs";
import TabComponent from "@material-ui/core/Tab";
import theme from "../theme";

const styles = () => ({
  root: {
    flexGrow: 1,
    overflow: "visible"
  },
  tabsRoot: {
    overflow: "visible",
    "& > div > div": {
      overflow: "visible",
      height: "54px"
    }
  },
  disabled: {
    "& > span > span > span": {
      fontSize: theme.fontSize.MEDIUM
    }
  },
  label: {
    fontSize: theme.fontSize.LARGE,
    textTransform: "capitalize",
    color: theme.palette.SECONDARY
  },
  tabsIndicator: {
    backgroundColor: theme.palette.PRIMARY,
    height: 6,
    boxShadow: "0px 3px 7px 0 rgba(0, 199, 178, 0.35)",
    bottom: "-1px"
  },
  tabSelected: {}
});

const CustomTabs = ({ classes, children, ...rest }) => {
  return (
    <TabsComponent
      classes={{ root: classes.tabsRoot, indicator: classes.tabsIndicator }}
      {...rest}
    >
      {children}
    </TabsComponent>
  );
};

CustomTabs.propTypes = {
  classes: PropTypes.shape({}),
  children: PropTypes.node.isRequired
};

CustomTabs.defaultProps = {
  classes: ""
};

export const Tabs = withStyles(styles)(CustomTabs);

const CustomTab = ({ classes, ...rest }) => {
  return (
    <TabComponent
      disableRipple
      classes={{
        root: classes.tabsRoot,
        label: `${classes.label} tab-custom-class`,
        disabled: classes.disabled
      }}
      {...rest}
    />
  );
};

CustomTab.propTypes = {
  classes: PropTypes.shape({})
};

CustomTab.defaultProps = {
  classes: ""
};

export const Tab = withStyles(styles)(CustomTab);
